export default {
	TITLE: 'Invalid Tenant Account',
	TEXT: 'Seems like there is a bug with your tenant. Logging out and in should fix the issue. Otherwise, contact IT',
	BUTTON_TEXT: 'Close modal',
};
